import { __module as d } from "./chunk663.js";
import { __require as I } from "./chunk447.js";
import { __require as J } from "./chunk448.js";
var P = d.exports, K;
function M() {
  return K ? d.exports : (K = 1, function(Q, j) {
    (function(m, A, p) {
      Q.exports = A(I(), J());
    })(P, function(m) {
      return function(A) {
        var p = m, q = p.lib, V = q.WordArray, x = q.Hasher, Y = p.x64, B = Y.Word, Z = p.algo, y = [], k = [], z = [];
        (function() {
          for (var r = 1, a = 0, o = 0; o < 24; o++) {
            y[r + 5 * a] = (o + 1) * (o + 2) / 2 % 64;
            var S = a % 5, s = (2 * r + 3 * a) % 5;
            r = S, a = s;
          }
          for (var r = 0; r < 5; r++)
            for (var a = 0; a < 5; a++)
              k[r + 5 * a] = a + (2 * r + 3 * a) % 5 * 5;
          for (var f = 1, c = 0; c < 24; c++) {
            for (var v = 0, u = 0, t = 0; t < 7; t++) {
              if (f & 1) {
                var e = (1 << t) - 1;
                e < 32 ? u ^= 1 << e : v ^= 1 << e - 32;
              }
              f & 128 ? f = f << 1 ^ 113 : f <<= 1;
            }
            z[c] = B.create(v, u);
          }
        })();
        var g = [];
        (function() {
          for (var r = 0; r < 25; r++)
            g[r] = B.create();
        })();
        var W = Z.SHA3 = x.extend({
          /**
           * Configuration options.
           *
           * @property {number} outputLength
           *   The desired number of bits in the output hash.
           *   Only values permitted are: 224, 256, 384, 512.
           *   Default: 512
           */
          cfg: x.cfg.extend({
            outputLength: 512
          }),
          _doReset: function() {
            for (var r = this._state = [], a = 0; a < 25; a++)
              r[a] = new B.init();
            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
          },
          _doProcessBlock: function(r, a) {
            for (var o = this._state, S = this.blockSize / 2, s = 0; s < S; s++) {
              var f = r[a + 2 * s], c = r[a + 2 * s + 1];
              f = (f << 8 | f >>> 24) & 16711935 | (f << 24 | f >>> 8) & 4278255360, c = (c << 8 | c >>> 24) & 16711935 | (c << 24 | c >>> 8) & 4278255360;
              var v = o[s];
              v.high ^= c, v.low ^= f;
            }
            for (var u = 0; u < 24; u++) {
              for (var t = 0; t < 5; t++) {
                for (var e = 0, h = 0, i = 0; i < 5; i++) {
                  var v = o[t + 5 * i];
                  e ^= v.high, h ^= v.low;
                }
                var R = g[t];
                R.high = e, R.low = h;
              }
              for (var t = 0; t < 5; t++)
                for (var b = g[(t + 4) % 5], F = g[(t + 1) % 5], N = F.high, C = F.low, e = b.high ^ (N << 1 | C >>> 31), h = b.low ^ (C << 1 | N >>> 31), i = 0; i < 5; i++) {
                  var v = o[t + 5 * i];
                  v.high ^= e, v.low ^= h;
                }
              for (var _ = 1; _ < 25; _++) {
                var e, h, v = o[_], n = v.high, H = v.low, l = y[_];
                l < 32 ? (e = n << l | H >>> 32 - l, h = H << l | n >>> 32 - l) : (e = H << l - 32 | n >>> 64 - l, h = n << l - 32 | H >>> 64 - l);
                var D = g[k[_]];
                D.high = e, D.low = h;
              }
              var E = g[0], X = o[0];
              E.high = X.high, E.low = X.low;
              for (var t = 0; t < 5; t++)
                for (var i = 0; i < 5; i++) {
                  var _ = t + 5 * i, v = o[_], w = g[_], U = g[(t + 1) % 5 + 5 * i], $ = g[(t + 2) % 5 + 5 * i];
                  v.high = w.high ^ ~U.high & $.high, v.low = w.low ^ ~U.low & $.low;
                }
              var v = o[0], G = z[u];
              v.high ^= G.high, v.low ^= G.low;
            }
          },
          _doFinalize: function() {
            var r = this._data, a = r.words;
            this._nDataBytes * 8;
            var o = r.sigBytes * 8, S = this.blockSize * 32;
            a[o >>> 5] |= 1 << 24 - o % 32, a[(A.ceil((o + 1) / S) * S >>> 5) - 1] |= 128, r.sigBytes = a.length * 4, this._process();
            for (var s = this._state, f = this.cfg.outputLength / 8, c = f / 8, v = [], u = 0; u < c; u++) {
              var t = s[u], e = t.high, h = t.low;
              e = (e << 8 | e >>> 24) & 16711935 | (e << 24 | e >>> 8) & 4278255360, h = (h << 8 | h >>> 24) & 16711935 | (h << 24 | h >>> 8) & 4278255360, v.push(h), v.push(e);
            }
            return new V.init(v, f);
          },
          clone: function() {
            for (var r = x.clone.call(this), a = r._state = this._state.slice(0), o = 0; o < 25; o++)
              a[o] = a[o].clone();
            return r;
          }
        });
        p.SHA3 = x._createHelper(W), p.HmacSHA3 = x._createHmacHelper(W);
      }(Math), m.SHA3;
    });
  }(d), d.exports);
}
export {
  M as __require
};
